// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"977":"65e7ab46","1754":"60a04cb1","4265":"60a04cb1","5394":"60a04cb1","6492":"e848c715","8733":"60a04cb1","9925":"b7bbdbc1"}[chunkId] + ".chunk.css";
};